export class HostingRedirectData {
  id: number;
  domainId: number;
  domainName: string;
  domainNameId: number;
  redirectFrom: string;
  redirectTo: string;
  statusCode: number;
}

